import React from 'react';
import { Link } from 'react-router-dom';

function Step0() {
  return (
    <div className="step step0">
      <h1>Herzlich willkommen bei VᴇʀA!</h1>

      <p>
        <strong>VᴇʀA</strong> (kurz für »Verantwortung« und »Algorithmen«, vera.arbeiterkammer.at) ist
        ein <strong>interaktives digitales Werkzeug</strong>, welches dabei helfen soll, Fragen
        der <strong>Verantwortlichkeit</strong> bei der Einführung
        von <strong>Algorithmen</strong> bestmöglich zu überblicken und drohende <strong>Kompetenzkonflikte
        und Verantwortungslücken</strong> frühzeitig zu erkennen. Es ist eine Ergänzung zum Leitfaden
        {' '}<a href="https://wien.arbeiterkammer.at/interessenvertretung/arbeitdigital/DataPolitics/Algorithmen_in_der_Entscheidungsfindung.html" target="_blank" rel="noreferrer">
          »Algorithmen in der Entscheidungsfindung – Leitfaden zu Verantwortlichkeit und
        Rechenschaft«</a>.
      </p>

      <p>
        Dieses digitale Tool bildet nicht alle der im Leitfaden zur Reflexion vermerkten Leitfragen ab. Es
        berücksichtigt nur jene, bei denen eine <strong>vernetzte Zusammenschau</strong> der verschiedenen
        Verantwortlichkeiten und Zuständigkeiten dabei helfen kann, <strong>organisationale
        Fehler</strong> in den Bezügen der verschiedenen Rollen untereinander zu vermeiden, bevor es zu
        Problem damit kommt. Dieses Werkzeug ist nur eine Hilfestellung, anhand welcher Fragen man die
        jeweils im Konkreten gegebene Situation betrachten kann; <strong>weitergehende Reflexion und
        Diskussion</strong> ist in jedem Fall notwendig, VᴇʀA kann hierzu nur einen Anstoß geben.
      </p>

      <p>
        Nachdem Sie in den folgenden zwei Schritten die Fragen zu den für Ihr algorithmisches
        System <strong>relevanten Personen(-gruppen)</strong> und ihren <strong>Zuständigkeiten und
        Verantwortlichkeiten</strong> ausgefüllt haben, erhalten Sie einen <strong>Überblick über
        potenzielle Probleme und Verantwortungslücken</strong>, die wir auf Basis Ihres Inputs erkennen
        können.
      </p>

      <div className="stepNav">
        <span />
        <Link className="btn btn-primary" to="/step1">Weiter</Link>
      </div>
    </div>
  );
}

export default Step0
;